export default {
  dashboard: {
    access: {
      table: {
        last_event: "Son Etkinlikler",
        personal: "Çalışan",
        terminal_type: "Terminal Tipi",
        general_info: "Genel Bilgilendirme",
        terminal: "Terminal",
        event_type: "Etkinlik Tipi",
        identity_type: "Kimlik Tipi",
        time: "Zaman",
        event: "Etkinlik",
        location: "Lokasyon",
        place: "Lokasyon",
        place_beacon: "Lokasyon Beacon",
        minor: "Minor",
        major: "Major",
        parent: "Bağlı olduğu lokasyon",
        duration: "Kaldığı Süre",
        first_seen: "Giriş zamanı",
        last_seen: "Çıkış zamanı",
        max_person_count: "Maksimumu Kişi Sayısı",
        begin_date_time: "Başlangıç zamanı",
        end_date_time: "Bitiş zamanı",
        employee_dialog_title: "Çalışan Giriş - Çıkış Bilgileri",
        empty_zone_message: "Bölgede hiç kimse yok",
        loading_message: "Oluşturuluyor"
      },
      monthly_dashboard: "Aylık Dashboard",
      monthly_events: "Aylık Olaylar",
      monthly_timesheet_report: "Aylık Zaman Çizelgesi Raporu",
      absence: "Devamsızlar",
      expected:"Beklenenlerim",
      incalculable: "Hesaplanamayanlar",
      lates: "Geç Gelenler",
      overtime: "Fazla Mesailer",
      early_leaver: "Erken Çıkanlar",
      missing_time: "Eksik Mesailer",
      total_tardiness_average: "Geç Kalma Ortalaması",
      total_leaver_average: "Erken Çıkma Ortalaması",
      total_overtime_average: "Fazla Mesai Ortalaması",
      tardiness_minute: "Geç kalma dakikası",
      early_minute: "Erken çıkma dakikası",
      overtime_minute: "Fazla mesai dakikası",
      short_minute: "dk",
      today: "Bugün"
    },
    currency: {
      buying: "Alış",
      selling: "Satış",
      currencies: "Döviz"
    },
    about: {
      about: "Hakkımızda",
      mission: "Misyon",
      vision: "Vizyon"
    },
    menu_of_day: "Günün Menüsü",
    messages: {
      no_data_reminders: "Hatırlatıcı bildirimi bulunmamaktadır",
      no_data_messages: "Mesaj bildirimi bulunmamaktadır",
      no_data_leaves: "İzin talebi bulunmamaktadır",
      no_data_overtimes: "Fazla mesai talebi bulunmamaktadır",
      no_data_expenses: "Harcama talebi bulunmamaktadır",
      no_data_imprests: "Avans talebi bulunmamaktadır",
      no_data_incalculables: "Hesaplanamayan çalışan bulunmuyor",
      no_data_absences: "Devamsız çalışan bulunmuyor"
    },
    request_type: {
      leave: "İzin Talepleri",
      overtime: "Fazla Mesai Talepleri",
      expense: "Harcama Talepleri",
      imprest: "Avans Talepleri"
    },
    weather_forecast: "Hava Durumu & Güncel Kurlar",
    reminder_tab_title: "Hatırlatıcılar",
    message_tab_title: "Mesajlar",
    data_type_enum: {
      LEAVE_REQUEST: "İzin Talepleri",
      ACTIVITY: "Etkinlikler",
      REMINDER: "Hatırlatıcılar"
    }
  }
};
